import { useParams } from "react-router-dom";
import QuizCourse from "../subjects/QuizCourse";
import { useQuery } from "@tanstack/react-query";
import LoadingPlaceholder from "../courses/LoadingPlaceholder";

const API_URL =
  process.env.REACT_APP_API_URL || "https://teamnepal-dev.bidhee.net/api";

const AskedBankQuiz = () => {
  const { slug } = useParams<{ slug: string }>();
  const course = useParams<{ id: string }>();

  const generateSetSequence = () => {
    const sets = [];
    for (let i = 65; i <= 90; i++) {
      // ASCII values: A=65, Z=90
      sets.push(`Set ${String.fromCharCode(i)}`);
    }
    return sets;
  };

  // Generate the same sequence available in QuizCourse
  const setSequence = generateSetSequence();

  const getAskedBankQuestions = async () => {
    const token = localStorage.getItem("asp-authv2");
    let headers: HeadersInit = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers["Authorization"] = `Bearer ${JSON.parse(token!)?.access}`;
    }

    try {
      const response = await fetch(
        `${API_URL}/course/${slug}/asked-bank-quiz/?limit=80`,
        { method: "GET", headers }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error fetching asked bank questions:", error);
      throw error;
    }
  };

  const getAskedBankQuestion = useQuery({
    queryKey: ["questionSet", course.id],
    queryFn: getAskedBankQuestions,
    staleTime: Infinity,
  });

  const refetchQuestionSet = () => {
    getAskedBankQuestion.refetch();
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          {/* Loading Placeholder */}
          {(getAskedBankQuestion.isLoading ||
            getAskedBankQuestion.isFetching) && (
            <div className="d-flex justify-content-center align-items-center min-vh-100">
              <LoadingPlaceholder />
            </div>
          )}

          {/* Error State */}
          {getAskedBankQuestion.isError && (
            <div className="alert alert-danger mx-3 mx-md-4 mt-4" role="alert">
              <h4 className="alert-heading">Error Loading Quiz</h4>
              <p className="mb-0">
                There was an error loading the quiz questions. Please try again
                later.
              </p>
              <hr />
              <button
                className="btn btn-outline-danger"
                onClick={() => getAskedBankQuestion.refetch()}
              >
                Try Again
              </button>
            </div>
          )}

          {/* Quiz Content */}
          {!getAskedBankQuestion.isLoading &&
            !getAskedBankQuestion.isFetching &&
            !getAskedBankQuestion.isError &&
            getAskedBankQuestion.data && (
              <QuizCourse
                refetchQuestionSet={refetchQuestionSet}
                slug={course.id}
                name={getAskedBankQuestion?.data?.[0]?.name || "Quiz"}
                QeustionSet={
                  getAskedBankQuestion?.data?.[0]?.quiz_questions || []
                }
              />
            )}

          {/* Empty State */}
          {!getAskedBankQuestion.isLoading &&
            !getAskedBankQuestion.isFetching &&
            !getAskedBankQuestion.isError &&
            (!getAskedBankQuestion.data ||
              !getAskedBankQuestion.data[0]?.quiz_questions?.length) && (
              <div className="text-center py-5">
                <div className="mx-3 mx-md-4">
                  <i className="fas fa-question-circle fa-3x text-muted mb-3"></i>
                  <h4 className="text-muted">No Questions Available</h4>
                  <p className="text-muted">
                    There are no quiz questions available for this course at the
                    moment.
                  </p>
                  <button
                    className="btn btn-primary"
                    onClick={() => getAskedBankQuestion.refetch()}
                  >
                    Refresh
                  </button>
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default AskedBankQuiz;
